var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.276,
    height: 18.276,
    viewBox: "0 0 18.276 18.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{fill:props.fill;}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "Icon_ionic-md-arrow-back",
    "data-name": "Icon ionic-md-arrow-back",
    d: "M24.252,13.972H10.374l6.4-6.4-1.656-1.6L5.977,15.114l9.138,9.138,1.6-1.6-6.339-6.4H24.252Z",
    transform: "translate(-5.977 -5.977)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBack);
export default __webpack_public_path__ + "static/media/icn-back.905744b7.svg";
export { ForwardRef as ReactComponent };